import SelectionSet from './selection-set';

export default SelectionSet;
